/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { BroadcastDetailsEntity } from '../model/broadcastDetailsEntity';
import { BroadcastNotificationEntity } from '../model/broadcastNotificationEntity';
import { IndDlrDealer } from '../model/indDlrDealer';
import { IndDlrRegionDetails } from '../model/indDlrRegionDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {baseUrl}from '../../../environments/environment';

@Injectable()
export class BroadcastSearchControllerService {

    //protected basePath = 'https://localhost:8080/nrfsi/nissan';
    protected basePath = baseUrl;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * addBroadcastNotification
     * 
     * @param notificationEntities notificationEntities
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addBroadcastNotificationUsingPOST(notificationEntities: Array<BroadcastNotificationEntity>, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastNotificationEntity>>;
    public addBroadcastNotificationUsingPOST(notificationEntities: Array<BroadcastNotificationEntity>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastNotificationEntity>>>;
    public addBroadcastNotificationUsingPOST(notificationEntities: Array<BroadcastNotificationEntity>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastNotificationEntity>>>;
    public addBroadcastNotificationUsingPOST(notificationEntities: Array<BroadcastNotificationEntity>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (notificationEntities === null || notificationEntities === undefined) {
            throw new Error('Required parameter notificationEntities was null or undefined when calling addBroadcastNotificationUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BroadcastNotificationEntity>>(`${this.basePath}broadcast/addBroadcastNotification`,
            notificationEntities,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchAllBroadcastNotification
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchAllBroadcastNotificationUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastDetailsEntity>>;
    public fetchAllBroadcastNotificationUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastDetailsEntity>>>;
    public fetchAllBroadcastNotificationUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastDetailsEntity>>>;
    public fetchAllBroadcastNotificationUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BroadcastDetailsEntity>>(`${this.basePath}broadcast/fetchAllBroadcastNotification`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchBroadcastCity
     * 
     * @param city city
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchBroadcastCityUsingPOST(city: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastDetailsEntity>>;
    public fetchBroadcastCityUsingPOST(city: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastDetailsEntity>>>;
    public fetchBroadcastCityUsingPOST(city: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastDetailsEntity>>>;
    public fetchBroadcastCityUsingPOST(city: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling fetchBroadcastCityUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BroadcastDetailsEntity>>(`${this.basePath}broadcast/fetchBroadcastCity`,
            city,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchBroadcastDealer
     * 
     * @param dealer dealer
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchBroadcastDealerUsingPOST(dealer: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastDetailsEntity>>;
    public fetchBroadcastDealerUsingPOST(dealer: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastDetailsEntity>>>;
    public fetchBroadcastDealerUsingPOST(dealer: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastDetailsEntity>>>;
    public fetchBroadcastDealerUsingPOST(dealer: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (dealer === null || dealer === undefined) {
            throw new Error('Required parameter dealer was null or undefined when calling fetchBroadcastDealerUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BroadcastDetailsEntity>>(`${this.basePath}broadcast/fetchbroadcastdealer`,
            dealer,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchBroadcastNotification
     * 
     * @param user user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchBroadcastNotificationUsingPOST(user: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastNotificationEntity>>;
    public fetchBroadcastNotificationUsingPOST(user: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastNotificationEntity>>>;
    public fetchBroadcastNotificationUsingPOST(user: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastNotificationEntity>>>;
    public fetchBroadcastNotificationUsingPOST(user: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling fetchBroadcastNotificationUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BroadcastNotificationEntity>>(`${this.basePath}broadcast/fetchBroadcastNotification`,
            user,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchBroadcastRegion
     * 
     * @param region region
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchBroadcastRegionUsingPOST(region: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastDetailsEntity>>;
    public fetchBroadcastRegionUsingPOST(region: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastDetailsEntity>>>;
    public fetchBroadcastRegionUsingPOST(region: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastDetailsEntity>>>;
    public fetchBroadcastRegionUsingPOST(region: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (region === null || region === undefined) {
            throw new Error('Required parameter region was null or undefined when calling fetchBroadcastRegionUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BroadcastDetailsEntity>>(`${this.basePath}broadcast/fetchBroadcastRegion`,
            region,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchCities
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchCitiesUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<IndDlrDealer>>;
    public fetchCitiesUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<IndDlrDealer>>>;
    public fetchCitiesUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<IndDlrDealer>>>;
    public fetchCitiesUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<IndDlrDealer>>(`${this.basePath}broadcast/fetchcities`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchDealer
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchDealerUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<IndDlrDealer>>;
    public fetchDealerUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<IndDlrDealer>>>;
    public fetchDealerUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<IndDlrDealer>>>;
    public fetchDealerUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<IndDlrDealer>>(`${this.basePath}broadcast/fetchdealer`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchRegion
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchRegionUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<IndDlrRegionDetails>>;
    public fetchRegionUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<IndDlrRegionDetails>>>;
    public fetchRegionUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<IndDlrRegionDetails>>>;
    public fetchRegionUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<IndDlrRegionDetails>>(`${this.basePath}broadcast/fetchregion`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
